export class SignExecuteRequest {
  width: number;
  height: number;
}
